// import api from '🔗/api';
import moment from 'moment';
import { ARTISTS_STATES } from '🔗/constants';
import stores from '@/stores';


export const ARTISTS_FILTERS = [
    {
        code: "name",
        type: "string",
        name: 'filter.artists.default.name'
    }, {
        code: "created_date",
        type: "date",
        range: true,
        name: 'filter.default.created-date',
        formatter: (values) => {
        	if (values?.length !== 2) {
        		return {};
        	}
        	return {
                created_date_lte: moment(values[1]).toISOString(),
        		created_date_gte: moment(values[0]).toISOString()
        	};
        }
    }, {
        code: "state",
        type: "autocomplete",
        multiple: false,
        name: 'filter.default.state',
        useI18n: true,
        options: [],
        onSearch: async (searchStr) => {
            const t = stores.locale().t();
            const str = searchStr?.trim().toLowerCase();

            if (!str) {
                return ARTISTS_STATES;
            }
            return ARTISTS_STATES.filter(item => t(item.name).toLowerCase().indexOf(str) !== -1);
        }
    // }, {
    //     code: "genres",
    //     type: "autocomplete",
    //     multiple: true,
    //     name: 'filter.default.genres',
    //     options: [],
    //     onSearch: async (searchStr) => {
    //         const params = {
    //             skip: 0,
    //             take: 20,
    //             sort: 'title',
    //             sort_dir: 'asc'
    //         }

    //         if (searchStr?.trim()) {
    //             params.title = searchStr.trim().toLowerCase();
    //         }

    //         const payload = await api.dict().genres.list(params);

    //         if (!payload?.items) {
    //             return [];
    //         }

    //         return payload.items.map(item => ({ code: item.code, name: item.title }));
    //     }
    // }, {
    //     code: "categories",
    //     type: "autocomplete",
    //     multiple: true,
    //     name: 'filter.default.categories',
    //     options: [],
    //     onSearch: async (searchStr) => {
    //         const params = {
    //             skip: 0,
    //             take: 20,
    //             sort: 'title',
    //             sort_dir: 'asc'
    //         }

    //         if (searchStr?.trim()) {
    //             params.title = searchStr.trim().toLowerCase();
    //         }

    //         const payload = await api.dict().categories.list(params);

    //         if (!payload?.items) {
    //             return [];
    //         }

    //         return payload.items.map(item => ({ code: item.code, name: item.title }));
    //     }
    }
]
